import { TableauCourse } from './types';
import { ENHANCED_TABLEAU_EXPERT_MODULE } from './enhanced-modules';

export const TABLEAU_EXPERT_COURSE: TableauCourse = {
  id: 'tableau-expert',
  title: 'Tableau Expert: Enterprise Analytics & Administration',
  description: 'Master enterprise Tableau deployment, advanced analytics integration, and Tableau Server administration.',
  level: 'expert',
  totalDuration: '18-20 hours',
  image: '/api/placeholder/400/300',
  prerequisites: [
    'Completed Tableau Intermediate course',
    'Extensive experience with Tableau Desktop',
    'Understanding of enterprise data architecture',
    'Basic knowledge of R/Python for analytics integration'
  ],
  learningOutcomes: [
    'Integrate advanced analytics with R and Python',
    'Administer Tableau Server for enterprise deployment',
    'Implement comprehensive data governance frameworks',
    'Develop custom extensions and integrations',
    'Build automated deployment and publishing workflows',
    'Lead center of excellence initiatives'
  ],
  modules: [
    ENHANCED_TABLEAU_EXPERT_MODULE
    // Additional expert modules would continue here...
  ]
};
